/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualUri: core.serialization.ObjectSchema<serializers.EqualUri.Raw, Truvity.EqualUri> =
    core.serialization.object({
        value: core.serialization.string(),
    });

export declare namespace EqualUri {
    export interface Raw {
        value: string;
    }
}
